import { createSlice } from "@reduxjs/toolkit";
import { SegmentActions } from "./Segment.actions";


interface SegProps{
    data:{
        getAllSegmentData:any,
        allPrefinedSegments:any,
        getAllSegmentDataLimit: boolean;
        getAllSegmentLimit: number;
        createSegmentData:any,
        deletedSegmentData:any,
        allContactListData:any,
        segmentDataCount:any,
        getAllSegmentConatctData: any
        segmentResponse:any
    },
    error:boolean,
    loading:boolean
}


const initialState : SegProps={
    data:{
        getAllSegmentData :[],
        allPrefinedSegments :[],
        getAllSegmentLimit: 0,
        getAllSegmentDataLimit: false,
        createSegmentData:null,
        deletedSegmentData:null,
        allContactListData: null,
        segmentDataCount:0,
        getAllSegmentConatctData: [],
        segmentResponse:null
    },
    error:false,
    loading:false
}



const SegmentSlice = createSlice({
    name : "SegmentSlice",
    initialState,
    reducers:{
        resetSegmentData: (state, action) => {
            return {
              ...state,
              getAllSegmentData: [],
              allPrefinedSegments: [],
            };
          },
    },
    extraReducers(builder) {
        //getAllSegmentListData
        builder.addCase(SegmentActions.getAllSegmentListData.pending , (state,action)=>{
            state.error = false;
            state.loading = true
        })

        .addCase(SegmentActions.getAllSegmentListData.fulfilled , (state,action)=>{
            state.data.getAllSegmentData = action.payload?.data.response?.segment_list
            state.data.segmentDataCount = action.payload?.data.response?.pagination
            state.data.segmentResponse = action.payload?.data.response
            state.data.getAllSegmentDataLimit = action.payload?.data?.response?.limit_exceeded
            state.data.getAllSegmentLimit = action.payload?.data?.response?.limit
            state.error = false;
            state.loading = false;
        })
        .addCase(SegmentActions.getAllSegmentListData.rejected , (state,action)=>{
            state.data.getAllSegmentData = []
            state.error = true;
            state.loading = false;
            state.data.segmentResponse = null
        })

        //allPrefinedSegments
        builder.addCase(SegmentActions.getAllPredefinedSegments.pending , (state,action)=>{
            state.error = false;
            state.loading = true
        })
        .addCase(SegmentActions.getAllPredefinedSegments.fulfilled , (state,action)=>{
            let updatedData = action.payload?.data.response?.segment_list
            state.data.allPrefinedSegments = updatedData
            // state.data.segmentDataCount = action.payload?.data.response?.pagination
            state.error = false;
            state.loading = false;
        })
        .addCase(SegmentActions.getAllPredefinedSegments.rejected , (state,action)=>{
            state.data.allPrefinedSegments = []
            state.error = true;
            state.loading = false;
        })

        //AllContactData

        .addCase(SegmentActions.getAllSegmentConatctListData.pending , (state,action)=>{
            state.error = false;
            state.loading = true
        })

        .addCase(SegmentActions.getAllSegmentConatctListData.fulfilled , (state,action)=>{
            state.data.getAllSegmentConatctData = action.payload?.data
            state.error = false;
            state.loading = false;
        })
        .addCase(SegmentActions.getAllSegmentConatctListData.rejected , (state,action)=>{
            state.data.getAllSegmentConatctData = []
            state.error = true;
            state.loading = false;
        })

        //createSegment
        .addCase(SegmentActions.createSegment.pending , (state,action)=>{
            state.error = false;
            state.loading = true
        })
        .addCase(SegmentActions.createSegment.fulfilled, (state,action)=>{
            state.data.createSegmentData = action.payload
            state.error = false;
            state.loading = false;
        })
        .addCase(SegmentActions.createSegment.rejected , (state,action)=>{
            state.error = true;
            state.loading = false;
        })
        //deleteSegmentById
        .addCase(SegmentActions.deleteSegmentById.pending , (state,action)=>{
            state.error = false;
            state.loading = true;
        })
        .addCase(SegmentActions.deleteSegmentById.fulfilled , (state,action)=>{
            state.data.deletedSegmentData = action.payload.data;
            state.error = false;
            state.loading = false;
        })
        .addCase(SegmentActions.deleteSegmentById.rejected , (state,action)=>{
            state.error = true;
            state.loading = false;
        })
    },

})
export const { resetSegmentData } = SegmentSlice.actions;
export default SegmentSlice.reducer